import { arrayAny } from "../../utils/arrayUtils";

export const LandlordSelector = ({ landlords, selectedLandlord, onLandlordSelect }) => {

    const firstLandlord = arrayAny(landlords) ? landlords[0] : null;

    return firstLandlord ? (

        <div className="mb-3 d-md-flex fw-bold">
            <div className="dropdown-toggle">
                <div style={{ cursor: "pointer" }}
                    data-bs-toggle="dropdown"
                    className="text-decoration-none text-dark">
                    <i className="far fa-user fa-fw text-dark text-opacity-50 me-1" />
                    {(selectedLandlord ?? firstLandlord).displayName}
                    <b className="ms-5px caret"></b>
                </div>

                <div className="dropdown-menu dropdown-menu-start">
                    {landlords.map(landlord => ( // For each landlord...
                        <div
                            onClick={() => onLandlordSelect(landlord)} style={{ cursor: "pointer" }}
                            key={landlord.id}
                            className="dropdown-item">
                            <i className="far fa-user fa-fw fa-lg text-gray-500 me-1" />{landlord.displayName}
                        </div>

                    ))}
                </div>
            </div>
        </div>
    )
        :
        (<>Loading...</>);
};